/*
  Comet Clothing — eigenes Verhalten.

  Grundregel wie beim CSS: Dawns Dateien bleiben unberuehrt. Was hier
  steht, ist Progressive Enhancement — faellt das Skript aus, bleibt
  Dawns Verhalten bestehen.
*/

(function () {
  'use strict';

  /* ----------------------------------------------------------------
     "Mehr anzeigen" statt Seitenzahlen

     Prada blaettert nicht: unter dem Raster steht ein unterstrichenes
     "MEHR ANZEIGEN", das die naechsten Artikel anhaengt.

     Umgesetzt, ohne Dawns Liquid zu aendern: Das Skript findet die
     vorhandene Seitennummerierung, blendet sie aus und setzt einen
     Knopf daneben. Ohne JavaScript bleibt die Nummerierung sichtbar
     und voll bedienbar — deshalb wird sie ausgeblendet und nicht
     entfernt.

     Filter und Sortierung bleiben erhalten, weil die Adresse der
     naechsten Seite unveraendert von Dawn uebernommen wird.
     ---------------------------------------------------------------- */

  /*
    Die Adresse der naechsten Seite aus einem Dokument holen.

    Dawn 16 setzt weder rel="next" noch eine Klasse --next: der Link
    zur naechsten Seite traegt ausgerechnet die Klasse
    pagination__item--prev, und das aria-label ist uebersetzt. Beides
    ist keine verlaessliche Grundlage.

    Stattdessen: Die Huelle traegt data-page mit der aktuellen Seite.
    Gesucht wird der Link, dessen page-Parameter genau eins hoeher ist.
    Das haengt weder an Dawns Klassennamen noch an der Sprache.
  */
  function naechsteAdresse(doc) {
    var huelle = doc.querySelector('.pagination-wrapper');
    if (!huelle) return null;

    var aktuell = parseInt(huelle.getAttribute('data-page'), 10);
    if (!aktuell) aktuell = 1;
    var gesucht = aktuell + 1;

    var links = huelle.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      var treffer = href && href.match(/[?&]page=(\d+)/);
      if (treffer && parseInt(treffer[1], 10) === gesucht) return href;
    }
    return null;
  }

  function mehrAnzeigen() {
    var huelle = document.querySelector('.pagination-wrapper');
    if (!huelle) return;

    var raster = document.querySelector('ul.product-grid');
    if (!raster) return;

    var adresse = naechsteAdresse(document);

    /* Eine Seite traegt 36 Teile (Julius 2026-10-03: am Rechner nicht
       staendig "Mehr anzeigen" klicken). Am Handy waeren das 18 Reihen
       am Stueck; dort zeigt der Knopf sie in Zwoelferschritten, ohne
       Netz. Ohne Skript stehen alle 36 da. */
    var schritt = 12;
    var handy = window.matchMedia('(max-width: 749px)').matches;
    var versteckt = [];

    function verstecken(eintraege) {
      if (!handy) return;
      Array.prototype.forEach.call(eintraege, function (eintrag) {
        eintrag.classList.add('hidden');
        versteckt.push(eintrag);
      });
    }

    function zeigeNaechste() {
      versteckt.splice(0, schritt).forEach(function (eintrag) {
        eintrag.classList.remove('hidden');
      });
    }

    verstecken(Array.prototype.slice.call(raster.children, schritt));

    if (!adresse && !versteckt.length) return;

    huelle.hidden = true;

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'comet-mehr';
    knopf.textContent = 'Mehr anzeigen';

    var bereich = document.createElement('div');
    bereich.className = 'comet-mehr__bereich';
    bereich.appendChild(knopf);

    // Neue Artikel werden angesagt, sonst merken Screenreader den
    // Nachschub nicht.
    var meldung = document.createElement('p');
    meldung.className = 'visually-hidden';
    meldung.setAttribute('aria-live', 'polite');
    bereich.appendChild(meldung);

    huelle.parentNode.insertBefore(bereich, huelle);

    var laeuft = false;

    knopf.addEventListener('click', function () {
      if (laeuft) return;

      if (versteckt.length) {
        var anzahl = Math.min(schritt, versteckt.length);
        zeigeNaechste();
        meldung.textContent = anzahl + ' weitere Artikel angezeigt.';
        if (!versteckt.length && !adresse) bereich.removeChild(knopf);
        return;
      }

      if (!adresse) return;
      laeuft = true;
      knopf.disabled = true;
      knopf.textContent = 'Wird geladen …';

      fetch(adresse)
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('Status ' + antwort.status);
          return antwort.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var neue = doc.querySelectorAll('ul.product-grid > li');
          if (!neue.length) throw new Error('keine Artikel gefunden');

          var angehaengt = [];
          Array.prototype.forEach.call(neue, function (eintrag) {
            angehaengt.push(raster.appendChild(document.importNode(eintrag, true)));
          });
          verstecken(angehaengt);
          zeigeNaechste();
          kartenrollen(raster);
          meldung.textContent = (handy ? Math.min(schritt, neue.length) : neue.length) + ' weitere Artikel geladen.';

          // Adresse der uebernaechsten Seite aus der geholten Seite.
          adresse = naechsteAdresse(doc);

          if (adresse || versteckt.length) {
            knopf.disabled = false;
            knopf.textContent = 'Mehr anzeigen';
          } else {
            bereich.removeChild(knopf);
          }
        })
        .catch(function () {
          // Im Fehlerfall zurueck auf Dawns Seitennummerierung. Besser
          // eine funktionierende Nummerierung als ein toter Knopf.
          bereich.parentNode.removeChild(bereich);
          huelle.hidden = false;
        })
        .finally(function () {
          laeuft = false;
        });
    });
  }


  /* ----------------------------------------------------------------
     Startbild-Video

     Zwei Fassungen liegen als Theme-Assets bereit (Handy hochkant,
     Rechner quer). Hier wird genau eine davon geladen, nie beide.
     Ohne Skript und bei "Bewegung reduzieren" bleibt das Bild stehen,
     das unter dem Video liegt. Nur transform/opacity gibt es hier nicht
     zu animieren: das Video laeuft von selbst, stumm und geloopt.
     ---------------------------------------------------------------- */

  function startbildVideo() {
    var video = document.querySelector('.comet-startbild__video[data-quelle-mobil], .comet-startbild__video[data-quelle-rechner]');
    if (!video) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Wer Daten spart oder auf langsamer Verbindung ist, bekommt das
    // Standbild. Eine Videoschleife von einem halben Megabyte ist dann
    // nicht hoeflich. Browser ohne diese Auskunft laden das Video.
    var verbindung = navigator.connection;
    if (verbindung) {
      if (verbindung.saveData) return;
      if (/(^|-)2g$|^3g$/.test(verbindung.effectiveType || '')) return;
    }

    // Die Section setzt die Quelle bereits waehrend des Parsens (siehe
    // comet-startbild.liquid). Steht dort schon eine, wird hier nur noch
    // der Rueckfall bei Fehlern und die Zurueck-Taste eingerichtet.
    var schonGesetzt = !!video.getAttribute('src');

    var gross = window.matchMedia('(min-width: 750px)').matches;
    var fassung = gross ? 'rechner' : 'mobil';
    var ersatz = gross ? 'mobil' : 'rechner';
    var h264 = video.getAttribute('data-quelle-' + fassung) || video.getAttribute('data-quelle-' + ersatz);
    var hevc = video.getAttribute('data-quelle-' + fassung + '-hevc');

    // HEVC (H.265) ist bei gleicher Schaerfe rund ein Drittel kleiner.
    // Nur laden, wenn der Browser es sicher kann (iPhone, die meisten
    // Android-Geraete); alle anderen bekommen H.264.
    var kannHevc = !!hevc && video.canPlayType('video/mp4; codecs="hvc1.1.6.L93.B0"') === 'probably';
    var quelle = kannHevc ? hevc : h264;
    if (!quelle) return;

    // Stumm auch als Eigenschaft setzen, nicht nur als Attribut: nur ein
    // stummes Video darf ohne Geste starten, und nicht jeder Browser
    // uebernimmt das Attribut zuverlaessig in die Eigenschaft.
    video.muted = true;
    video.defaultMuted = true;

    // Laesst sich die HEVC-Datei wider Erwarten nicht abspielen, auf
    // H.264 wechseln statt das Bild stehen zu lassen.
    if (kannHevc && h264) {
      video.addEventListener('error', function wechsel() {
        video.removeEventListener('error', wechsel);
        video.src = h264;
        video.load();
        abspielen(video);
      });
    }

    if (!schonGesetzt) {
      // Die Section wartet mit dem Video aufs Startbild und setzt die
      // Quelle dann selbst (data-wartet). Hier nicht vorgreifen.
      if (!video.hasAttribute('data-wartet')) {
        video.src = quelle;
        video.load();
        abspielen(video);
      }
    } else if (video.paused) {
      abspielen(video);
    }

    // Zurueck aus dem Seitenspeicher (Zurueck-Taste): weiterlaufen lassen.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && video.paused && !video.hasAttribute('data-angehalten')) abspielen(video);
    });

    pauseKnopf(video);
  }

  /*
    Pause-Knopf (Durchsicht 2026-10-04: endlose Bewegung ohne Halt
    verletzt WCAG 2.2.2). Klein, unten rechts, erst sichtbar, wenn das
    Video wirklich laeuft. Wer anhaelt, bleibt angehalten: die
    Nachhol-Versuche in abspielen() fragen data-angehalten ab.
  */
  function pauseKnopf(video) {
    var buehne = video.closest('.comet-startbild');
    if (!buehne || buehne.querySelector('.comet-startbild__pause')) return;

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'comet-startbild__pause';
    knopf.hidden = true;
    knopf.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">' +
      '<rect class="comet-startbild__pause-an" x="2" y="1.5" width="2.6" height="9" />' +
      '<rect class="comet-startbild__pause-an" x="7.4" y="1.5" width="2.6" height="9" />' +
      '<path class="comet-startbild__pause-aus" d="M3 1.5 L10.5 6 L3 10.5 Z" /></svg>';
    buehne.appendChild(knopf);

    function stand() {
      var haelt = video.paused;
      knopf.setAttribute('aria-label', haelt ? 'Video abspielen' : 'Video anhalten');
      knopf.classList.toggle('comet-startbild__pause--haelt', haelt);
    }

    video.addEventListener('playing', function () {
      knopf.hidden = false;
      stand();
    });
    video.addEventListener('pause', stand);
    if (!video.paused) {
      knopf.hidden = false;
      stand();
    }

    knopf.addEventListener('click', function () {
      if (video.paused) {
        video.removeAttribute('data-angehalten');
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.setAttribute('data-angehalten', '1');
        video.pause();
      }
      stand();
    });
  }

  /*
    Abspielen, und wenn der Browser das ohne Geste verweigert (iOS im
    Stromsparmodus, eingebettete Browser in Apps), beim ersten Tippen
    oder Tastendruck nachholen. Der Datensparmodus ist kein Fehler:
    bis dahin steht das Bild darunter.
  */
  function abspielen(video) {
    // Sicherheitsnetz: falls die Section das Schnipsel nicht ausgeliefert
    // hat, wird das Video hier sichtbar gemacht, sobald es laeuft.
    if (!video.classList.contains('comet-startbild__video--laeuft')) {
      video.addEventListener('playing', function () {
        video.classList.add('comet-startbild__video--laeuft');
      }, { once: true });
    }

    var versuch = video.play();
    if (!versuch || typeof versuch.catch !== 'function') return;

    versuch.catch(function () {
      // Bevor auf eine Geste gewartet wird: noch einmal versuchen, sobald
      // Daten da sind. Ein zurueckgewiesenes play() heisst oft nur "noch
      // nichts geladen", nicht "verboten" — und dann laeuft es ohne
      // Zutun weiter. Erst wenn auch das scheitert, zaehlt die Geste.
      ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (n) {
        video.addEventListener(n, function () {
          if (!video.paused || video.hasAttribute('data-angehalten')) return;
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }, { once: true });
      });

      // Zurueck im Bild oder Tab wieder vorn: noch ein Versuch.
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && video.paused && !video.hasAttribute('data-angehalten')) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });

      // Kein 'scroll' in dieser Liste. Scrollen ist keine Nutzergeste im
      // Sinne der Autoplay-Regeln — es erlaubt kein play(). Es feuert aber
      // sofort, haengt dadurch alle Horcher ab, und ein spaeteres echtes
      // Antippen kaeme nie mehr an. (Durchsicht 2026-09-10, selbst
      // eingebaut und hier wieder entfernt.)
      var ereignisse = ['touchend', 'touchstart', 'pointerdown', 'click', 'keydown'];
      var nachholen = function () {
        ereignisse.forEach(function (name) {
          document.removeEventListener(name, nachholen, true);
        });
        if (video.hasAttribute('data-angehalten')) return;
        var zweiter = video.play();
        if (zweiter && typeof zweiter.catch === 'function') zweiter.catch(function () {});
      };
      ereignisse.forEach(function (name) {
        document.addEventListener(name, nachholen, { capture: true, passive: true });
      });
    });
  }

  /* ----------------------------------------------------------------
     Leere Masszeilen in der Beschreibung ausblenden

     Dropstitchs Vorlage schreibt "Pit to pit / Waist: cm" und
     "Length / Inseam: cm" auch ohne Wert; Julius traegt die Masse von
     Hand nach (Erik 2026-10-04). Bis dahin verschwinden Zeilen, die nur
     aus Bezeichnung, Doppelpunkt und hoechstens "cm" bestehen — und eine
     Ueberschrift "Masse:", unter der dann nichts mehr steht. Steht ein
     Wert da, bleibt alles, wie es ist. Nur Anzeige, Daten unberuehrt.
     ---------------------------------------------------------------- */

  var LEER_ZEILE = /^\s*(pit to pit|length|inseam|waist|size|größe|groesse)[^:]{0,40}:\s*(cm)?\s*$/i;
  var MASS_KOPF = /^\s*(maße|masse|measurements)\s*:?\s*$/i;

  function zeilenVon(block) {
    var zeilen = [[]];
    Array.prototype.forEach.call(block.childNodes, function (k) {
      if (k.nodeName === 'BR') {
        zeilen[zeilen.length - 1].push(k);
        zeilen.push([]);
      } else {
        zeilen[zeilen.length - 1].push(k);
      }
    });
    return zeilen;
  }

  function text(knoten) {
    return knoten.filter(function (k) { return k.nodeName !== 'BR'; })
      .map(function (k) { return k.textContent; }).join('');
  }

  function leereMasse() {
    var bereiche = document.querySelectorAll('#Comet-Aufklapper-beschreibung, .product__description');
    Array.prototype.forEach.call(bereiche, function (bereich) {
      Array.prototype.forEach.call(bereich.querySelectorAll('p, div, li'), function (block) {
        if (block.querySelector('p, div, li')) return;
        var zeilen = zeilenVon(block);
        var weg = zeilen.map(function (z) { return LEER_ZEILE.test(text(z)); });
        // Ueberschrift "Masse:" weg, wenn alle Zeilen danach im Block leer sind.
        zeilen.forEach(function (z, i) {
          if (!MASS_KOPF.test(text(z))) return;
          var rest = weg.slice(i + 1);
          var echteRest = zeilen.slice(i + 1).filter(function (r) { return text(r).trim() !== ''; });
          if (echteRest.length && rest.every(function (w, j) { return w || text(zeilen[i + 1 + j]).trim() === ''; })) weg[i] = true;
          if (!echteRest.length) weg[i] = 'kopf-allein';
        });
        zeilen.forEach(function (z, i) {
          if (weg[i] === true) z.forEach(function (k) { k.remove(); });
        });
        if (block.textContent.trim() === '') block.remove();
      });
      // "Masse:" als eigener Absatz, dessen Folgeabsaetze alle verschwunden sind.
      Array.prototype.forEach.call(bereich.querySelectorAll('p'), function (p) {
        if (!MASS_KOPF.test(p.textContent)) return;
        var naechster = p.nextElementSibling;
        if (!naechster || MASS_KOPF.test(naechster.textContent) || naechster.tagName !== 'P' || /^\s*$/.test(naechster.textContent)) p.remove();
      });
    });
  }

  /* ----------------------------------------------------------------
     Empfehlungen ("Das koennte dir auch gefallen")

     Dawn holt die Karten nachtraeglich und setzt sie per innerHTML ein.
     Am iPhone blieb dabei das erste Bild einer Karte leer (Erik
     2026-10-05: nur das erste geladen, Alt-Text statt Foto) — Safari
     wertet loading="lazy" in nachgesetzten, waagerecht rollenden
     Reihen unzuverlaessig aus. Die Titelbilder der Empfehlungen laden
     deshalb sofort (es sind hoechstens acht kleine), die Folgebilder
     richtet kartenrollen() wie ueberall ein.
     ---------------------------------------------------------------- */

  function empfehlungen() {
    Array.prototype.forEach.call(document.querySelectorAll('product-recommendations'), function (el) {
      if (el.hasAttribute('data-comet')) return;
      el.setAttribute('data-comet', '1');
      var einrichten = function () {
        Array.prototype.forEach.call(el.querySelectorAll('.comet-kartenrolle__bild:first-child img[loading="lazy"], .card__media img[loading="lazy"]'), function (img) {
          if (img.closest('.comet-kartenrolle__bild--spaeter')) return;
          img.setAttribute('loading', 'eager');
        });
        kartenrollen(el);
      };
      if (el.querySelector('.card-wrapper, .comet-kartenrolle')) einrichten();
      new MutationObserver(function () {
        if (el.querySelector('.card-wrapper, .comet-kartenrolle')) einrichten();
      }).observe(el, { childList: true, subtree: true });
    });
  }

  /* ----------------------------------------------------------------
     Kollektionsseite nach dem Filtern nachziehen

     Dawns Filter (Schublade bzw. Klappmenues) laden nur das Raster und
     die Adresse neu. Unsere Leisten darueber (comet-kollleiste) sind
     serverseitig gebaut und blieben stehen: Sortieren warf dann den
     gewaehlten Filter weg, und oben stand weiter die alte Teilezahl
     (Durchsicht 2026-10-04, Befund 1 und 2). Nach jedem Neuladen des
     Rasters werden die Links aus der aktuellen Adresse neu gebaut,
     die Zahl aus Dawns #ProductCount uebernommen und "Mehr anzeigen"
     neu eingerichtet.
     ---------------------------------------------------------------- */

  function kollleisteNachziehen() {
    var leiste = document.querySelector('.comet-kollleiste');
    if (!leiste) return;
    var jetzt = new URLSearchParams(window.location.search);
    jetzt.delete('page');

    Array.prototype.forEach.call(leiste.querySelectorAll('a[data-sort]'), function (a) {
      var p = new URLSearchParams(jetzt);
      p.set('sort_by', a.getAttribute('data-sort'));
      a.href = window.location.pathname + '?' + p.toString();
      var aktiv = (jetzt.get('sort_by') || '') === a.getAttribute('data-sort');
      if (jetzt.get('sort_by')) a.classList.toggle('comet-filter__eintrag--aktiv', aktiv);
    });

    var groessen = leiste.querySelector('.comet-filter--groessen');
    if (groessen) {
      var param = groessen.getAttribute('data-param');
      var gewaehlt = jetzt.getAll(param);
      Array.prototype.forEach.call(groessen.querySelectorAll('a[data-wert]'), function (a) {
        var wert = a.getAttribute('data-wert');
        var p = new URLSearchParams(jetzt);
        p.delete(param);
        if (wert) p.append(param, wert);
        a.href = window.location.pathname + '?' + p.toString();
        var aktiv = wert ? (gewaehlt.length === 1 && gewaehlt[0] === wert) : gewaehlt.length === 0;
        a.classList.toggle('comet-filter__eintrag--aktiv', aktiv);
        if (aktiv) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    var quelle = document.getElementById('ProductCount');
    var zahl = leiste.querySelector('.comet-kollleiste__zahl');
    var n = quelle ? parseInt(quelle.getAttribute('data-product-count'), 10) : NaN;
    if (zahl && !isNaN(n)) zahl.textContent = n + (n === 1 ? ' Teil' : ' Teile');
  }

  function filterNachladen() {
    var raster = document.getElementById('ProductGridContainer');
    if (!raster || !document.querySelector('.comet-kollleiste')) return;
    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      // Dawn setzt Raster, Zahl und Adresse kurz nacheinander.
      requestAnimationFrame(function () {
        wartet = false;
        kollleisteNachziehen();
        mehrAnzeigen();
        kartenrollen();
      });
    }).observe(raster, { childList: true });
    window.addEventListener('popstate', function () {
      setTimeout(kollleisteNachziehen, 0);
    });
  }

  /* ----------------------------------------------------------------
     Gleitender Auswahlstrich der Filterleisten

     Gilt fuer Sortierung und Groessen auf den Kollektionsseiten, die
     Leisten des Startseiten-Katalogs und "Fuer sie / Fuer ihn". Je
     Leiste ein Strich, der per transform zum aktiven Eintrag gleitet
     (Lage und Breite, Kurve und Dauer im CSS).

     Woher der Strich weiss, wohin:
     - Startseiten-Katalog: katalog() wechselt die Klasse --aktiv,
       ein MutationObserver bemerkt das.
     - "Fuer sie / Fuer ihn": Radios, Ereignis change.
     - Kollektionsseiten: die Eintraege sind Links, ein Klick laedt
       die Seite neu. Der Strich startet beim Antippen und gleitet,
       waehrend die neue Seite laedt. Kommt jemand per Zurueck-Taste
       aus dem Zwischenspeicher, steht er wieder am Ausgangspunkt.
     ---------------------------------------------------------------- */

  function filterlinien() {
    var leisten = document.querySelectorAll('.comet-filter, .kat-umschalter');

    Array.prototype.forEach.call(leisten, function (leiste) {
      if (leiste.getAttribute('data-linie')) return;
      var eintraege = leiste.querySelectorAll('.comet-filter__eintrag');
      if (!eintraege.length) return;
      leiste.setAttribute('data-linie', '1');

      var linie = document.createElement('span');
      linie.className = 'comet-filter__linie';
      linie.setAttribute('aria-hidden', 'true');
      leiste.appendChild(linie);
      leiste.classList.add('comet-filter--linie');

      function aktiver() {
        var a = leiste.querySelector('.comet-filter__eintrag--aktiv');
        if (a) return a;
        var radio = leiste.querySelector('.kat-umschalter__radio:checked');
        return radio ? leiste.querySelector('label[for="' + radio.id + '"]') : null;
      }

      function setzen(ziel, weich) {
        if (!ziel || !ziel.offsetWidth) {
          linie.style.opacity = '0';
          return;
        }
        // Wie die ::after-Linie: um 0,5 rem eingerueckt, am unteren Rand.
        var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
        var x = ziel.offsetLeft + 0.5 * rem;
        var y = ziel.offsetTop + ziel.offsetHeight - linie.offsetHeight;
        var breite = Math.max(ziel.offsetWidth - rem, 1);
        if (!weich) linie.style.transition = 'none';
        linie.style.transform = 'translate(' + x + 'px, ' + y + 'px) scaleX(' + breite / 100 + ')';
        linie.style.opacity = '1';
        if (!weich) {
          linie.getBoundingClientRect();
          linie.style.transition = '';
        }
      }

      var anfang = aktiver();
      setzen(anfang, false);

      new MutationObserver(function () {
        setzen(aktiver(), true);
      }).observe(leiste, { attributes: true, attributeFilter: ['class'], subtree: true });

      leiste.addEventListener('change', function () {
        setzen(aktiver(), true);
      });

      if (leiste.closest('.comet-kollleiste')) {
        leiste.addEventListener('click', function (e) {
          var ziel = e.target.closest('a.comet-filter__eintrag');
          if (!ziel || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          Array.prototype.forEach.call(eintraege, function (x) {
            x.classList.toggle('comet-filter__eintrag--aktiv', x === ziel);
          });
        });
        window.addEventListener('pageshow', function (e) {
          if (!e.persisted) return;
          Array.prototype.forEach.call(eintraege, function (x) {
            x.classList.toggle('comet-filter__eintrag--aktiv', x === anfang);
          });
          setzen(anfang, false);
        });
      }

      var wartet = false;
      window.addEventListener('resize', function () {
        if (wartet) return;
        wartet = true;
        requestAnimationFrame(function () {
          wartet = false;
          setzen(aktiver(), false);
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     Katalog auf der Startseite

     Die Section rendert acht Teile, vier davon versteckt. Der erste
     Klick auf "Mehr anzeigen" zeigt die vier ohne Netz. Danach holt
     das Skript die Kollektionsseite (dieselbe Adresse, auf die die
     Links ohne Skript fuehren) und uebernimmt deren Karten, wie
     mehrAnzeigen() auf den Kollektionsseiten. Filterklicks tauschen
     die Quelle (Geschlecht: andere Kollektion) oder den Query-String
     (Groesse) und laden das Raster neu. Die Adresse im Browser bleibt
     die Startseite.

     Karten, die schon im Raster stehen (gleiche Produktadresse),
     werden beim Anhaengen uebersprungen: die erste geholte Seite
     enthaelt die acht Teile aus Liquid noch einmal.
     ---------------------------------------------------------------- */

  function katalog() {
    var bereiche = document.querySelectorAll('.comet-katalog');

    Array.prototype.forEach.call(bereiche, function (bereich) {
      var raster = bereich.querySelector('.comet-katalog__raster');
      var link = bereich.querySelector('.comet-katalog__mehr');
      var meldung = bereich.querySelector('.comet-katalog__meldung');
      var hinweis = bereich.querySelector('.comet-katalog__hinweis');
      if (!raster || !link) return;

      var zustand = {
        quelle: bereich.getAttribute('data-quelle') || '/collections/all',
        filter: '',
        sort: bereich.getAttribute('data-sort') || '',
        seite: 0,
        laeuft: false,
        // Eine Kollektionsseite traegt 36 Teile; die Startseite nimmt
        // davon 12 je Schritt und haelt den Rest hier vor.
        vorrat: [],
        nochSeite: false
      };
      var SCHRITT = 12;
      var versteckte = Array.prototype.slice.call(raster.querySelectorAll('li[hidden]'));

      // Aus dem Link wird ein Knopf; der Link bleibt als Rueckfall im DOM.
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = link.className;
      knopf.textContent = link.textContent;
      var knopfText = knopf.textContent;
      link.hidden = true;
      link.parentNode.insertBefore(knopf, link);

      function adresse(seite) {
        var teile = [];
        if (zustand.filter) teile.push(zustand.filter);
        if (zustand.sort) teile.push('sort_by=' + zustand.sort);
        if (seite > 1) teile.push('page=' + seite);
        return zustand.quelle + (teile.length ? '?' + teile.join('&') : '');
      }

      /* Erik 2026-09-09: "Der 'Mehr anzeigen' sollte man nur 2x antippen,
         dann wird daraus ein 'Alles anzeigen' btn." Nach zwei Tipps ist
         die Reihe lang genug; wer dann noch mehr will, gehoert auf die
         Kollektionsseite statt in eine endlos wachsende Startseite.

         Umgesetzt als Rueckkehr zum Link, der ohnehin schon als Rueckfall
         ohne JavaScript im DOM liegt: echter Seitenwechsel, mittlere
         Maustaste und "in neuem Tab oeffnen" funktionieren. */
      var tipps = 0;
      var GRENZE = 2;

      function allesAnzeigen() {
        var hatteFokus = document.activeElement === knopf;
        link.href = adresse(1);
        link.textContent = 'Alles anzeigen';
        link.hidden = false;
        knopf.hidden = true;
        // Der Knopf verschwindet unter dem Fokus weg; der Link uebernimmt
        // ihn, sonst faellt die Tastatur an den Seitenanfang zurueck.
        if (hatteFokus) link.focus();
      }

      function zurueckAufMehr() {
        tipps = 0;
        link.hidden = true;
        link.textContent = knopfText;
        knopf.textContent = knopfText;
        knopf.hidden = false;
      }

      function vorhandene() {
        var menge = {};
        Array.prototype.forEach.call(raster.querySelectorAll('a[href*="/products/"]'), function (a) {
          menge[a.getAttribute('href').split('?')[0]] = true;
        });
        return menge;
      }

      function einsetzen(karten, ersetzen) {
        if (ersetzen) raster.innerHTML = '';
        var schon = vorhandene();
        var neue = 0;
        Array.prototype.forEach.call(karten, function (li) {
          var a = li.querySelector('a[href*="/products/"]');
          var schluessel = a ? a.getAttribute('href').split('?')[0] : null;
          if (schluessel && schon[schluessel]) return;
          var karte = document.importNode(li, true);
          karte.classList.add('comet-karte');
          karte.classList.remove('scroll-trigger', 'animate--slide-in');
          karte.removeAttribute('hidden');
          raster.appendChild(karte);
          if (schluessel) schon[schluessel] = true;
          neue += 1;
        });
        return neue;
      }

      function melden(text) {
        if (meldung) meldung.textContent = text;
      }

      function laden(ersetzen) {
        zustand.laeuft = true;
        knopf.disabled = true;
        knopf.textContent = 'Wird geladen …';
        bereich.classList.add('comet-katalog--laedt');

        fetch(adresse(zustand.seite))
          .then(function (antwort) {
            if (!antwort.ok) throw new Error('Status ' + antwort.status);
            return antwort.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var karten = Array.prototype.slice.call(doc.querySelectorAll('ul.product-grid > li'));
            zustand.vorrat = karten.slice(SCHRITT);
            zustand.nochSeite = !!naechsteAdresse(doc);
            var neue = einsetzen(karten.slice(0, SCHRITT), ersetzen);
            var weiter = zustand.nochSeite || zustand.vorrat.length > 0;
            if (ersetzen) {
              melden(karten.length ? karten.length + ' Teile geladen.' : (hinweis ? hinweis.textContent : 'Keine Teile in dieser Auswahl.'));
            } else {
              melden(neue + ' weitere Teile geladen.');
            }
            // Sichtbarer Hinweis, wenn ein Filter nichts findet (auch solange
            // Groessen im Shop noch nicht hinterlegt sind).
            kartenrollen(raster);
            if (hinweis) hinweis.hidden = karten.length > 0;
            knopf.hidden = !weiter || karten.length === 0;
            knopf.disabled = false;
            knopf.textContent = knopfText;
            // Zwei Tipps sind genug — ab hier fuehrt der Weg auf die
            // Kollektionsseite, aber nur wenn es dort ueberhaupt mehr gibt.
            if (tipps >= GRENZE && weiter && karten.length > 0) allesAnzeigen();
          })
          .catch(function () {
            // Rueckfall: der Link auf die Kollektionsseite kommt zurueck.
            link.href = adresse(1);
            link.hidden = false;
            knopf.remove();
          })
          .finally(function () {
            zustand.laeuft = false;
            bereich.classList.remove('comet-katalog--laedt');
          });
      }

      knopf.addEventListener('click', function () {
        if (zustand.laeuft) return;
        tipps += 1;
        if (versteckte.length) {
          versteckte.forEach(function (li) {
            li.hidden = false;
          });
          melden(versteckte.length + ' weitere Teile.');
          versteckte = [];
          kartenrollen(raster);
          // Das Aufdecken holt nichts nach, entscheidet also hier selbst.
          if (tipps >= GRENZE) allesAnzeigen();
          return;
        }
        if (zustand.vorrat.length) {
          melden(einsetzen(zustand.vorrat.splice(0, SCHRITT), false) + ' weitere Teile.');
          kartenrollen(raster);
          var mehr = zustand.vorrat.length > 0 || zustand.nochSeite;
          knopf.hidden = !mehr;
          if (tipps >= GRENZE && mehr) allesAnzeigen();
          return;
        }
        zustand.seite += 1;
        laden(false);
      });

      Array.prototype.forEach.call(bereich.querySelectorAll('.comet-filter'), function (leiste) {
        leiste.addEventListener('click', function (e) {
          var eintrag = e.target.closest('.comet-filter__eintrag');
          if (!eintrag || zustand.laeuft) return;
          e.preventDefault();

          if (eintrag.hasAttribute('data-quelle')) {
            zustand.quelle = eintrag.getAttribute('data-quelle');
            // Groessenlinks zeigen ohne Skript auf die neue Kollektion.
            Array.prototype.forEach.call(bereich.querySelectorAll('.comet-filter--groessen .comet-filter__eintrag'), function (g) {
              var f = g.getAttribute('data-filter');
              g.href = zustand.quelle + (f ? '?' + f : '');
            });
          } else {
            zustand.filter = eintrag.getAttribute('data-filter') || '';
          }

          Array.prototype.forEach.call(leiste.querySelectorAll('.comet-filter__eintrag'), function (x) {
            var aktiv = x === eintrag;
            x.classList.toggle('comet-filter__eintrag--aktiv', aktiv);
            if (aktiv) x.setAttribute('aria-current', 'true');
            else x.removeAttribute('aria-current');
          });

          versteckte = [];
          zustand.seite = 1;
          if (knopf.parentNode) zurueckAufMehr();
          laden(true);
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     Marken: ein Bild, das ueberblendet (Etappe 2c)

     Eine versteckte Datenliste (span[data-marke]) traegt je Marke
     data-name, data-url, data-bild und data-srcset — sie ist die
     Datenquelle; sichtbar ist nur die Buehne (Erik: clean, keine Zeile).
     Nach `dauer` Sekunden Stand wird das naechste Bild geladen, ueber
     das alte gelegt und in 1,5 s weich per Deckkraft eingeblendet; das alte bleibt
     darunter, bis das neue steht, dann fliegt es raus. So ist nie
     mehr als ein Bild zusaetzlich im Speicher, und es gibt keinen
     Helligkeitseinbruch. Text wechselt mit kurzer Blende.

     Pausen ohne Ruecksetzen der Restzeit: Buehne nicht im Bild, Tab
     verborgen, Zeiger auf der Section (nur mit echter Maus), Fokus in
     der Section. Bei "Bewegung reduzieren" laeuft kein Zeitgeber. Im
     Theme-Editor zeigt ein angeklickter Block sein Bild.
     ---------------------------------------------------------------- */
  function marken() {
    var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var maus = window.matchMedia('(hover: hover)').matches;
    var editor = !!(window.Shopify && window.Shopify.designMode);

    document.querySelectorAll('.comet-marken').forEach(function (wurzel) {
      if (wurzel.dataset.marken) return;
      wurzel.dataset.marken = '1';

      var buehne = wurzel.querySelector('.comet-marken__buehne');
      var text = wurzel.querySelector('[data-text]');
      var nameEl = wurzel.querySelector('[data-name]');
      var eintraege = Array.prototype.slice.call(
        wurzel.querySelectorAll('[data-marke]')
      );
      if (!buehne || !text || !nameEl || eintraege.length === 0) return;

      var dauer = (parseFloat(wurzel.dataset.dauer) || 2.5) * 1000;
      /* Die Blendendauern stehen in comet-marken.liquid als eigene
         Eigenschaften. Von dort gelesen statt hier abgeschrieben — sonst
         raeumt das JS das alte Bild weg, waehrend die Blende noch laeuft. */
      function msAus(name, ersatz) {
        var roh = getComputedStyle(wurzel).getPropertyValue(name).trim();
        var zahl = parseFloat(roh);
        if (!zahl) return ersatz;
        return /ms$/.test(roh) ? zahl : zahl * 1000;
      }
      var blende = msAus('--comet-marken-blende', 1500);
      var textblende = msAus('--comet-marken-textblende', 500);
      var aktuell = 0;
      var laeuft = false;
      var timer = null;
      var rest = dauer;
      var faellig = 0;
      var imBild = false;
      var verborgen = document.hidden;
      var zeiger = false;
      var fokus = false;

      function darfLaufen() {
        return imBild && !verborgen && !zeiger && !fokus && !laeuft;
      }

      function plane() {
        if (timer !== null || editor || reduziert || eintraege.length < 2) return;
        if (!darfLaufen()) return;
        faellig = Date.now() + rest;
        timer = setTimeout(tick, rest);
      }

      function halt() {
        if (timer === null) return;
        clearTimeout(timer);
        timer = null;
        rest = Math.max(250, faellig - Date.now());
      }

      function tick() {
        timer = null;
        rest = dauer;
        if (!darfLaufen()) return;
        zeige((aktuell + 1) % eintraege.length, false);
      }

      function zeige(index, sofort) {
        var e = eintraege[index];
        if (!e || laeuft || index === aktuell) return;
        laeuft = true;
        var ohneBlende = sofort || reduziert;
        var img = new Image();
        img.className = 'comet-marken__bild';
        img.alt = e.dataset.name || '';
        img.decoding = 'async';

        img.addEventListener('load', function () {
          var alte = Array.prototype.slice.call(
            buehne.querySelectorAll('.comet-marken__bild')
          );
          buehne.insertBefore(img, text);
          if (ohneBlende) {
            img.classList.add('comet-marken__bild--sichtbar');
          } else {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                img.classList.add('comet-marken__bild--sichtbar');
              });
            });
          }
          text.classList.add('comet-marken__text--wechselt');
          setTimeout(function () {
            nameEl.textContent = e.dataset.name || '';
            img.alt = e.dataset.name || '';
            if (e.dataset.url) buehne.href = e.dataset.url;
            text.classList.remove('comet-marken__text--wechselt');
          }, ohneBlende ? 0 : textblende);
          aktuell = index;
          setTimeout(function () {
            alte.forEach(function (a) { a.remove(); });
            laeuft = false;
            /* Standzeit beginnt nach der Blende: `dauer` ruhig stehen,
               dann der naechste weiche Wechsel. */
            rest = dauer;
            plane();
          }, ohneBlende ? 0 : blende + 50);
        }, { once: true });

        img.addEventListener('error', function () {
          /* Eintrag ueberspringen: als aktuell merken, bald weiter. */
          aktuell = index;
          laeuft = false;
          rest = 250;
          plane();
        }, { once: true });

        img.sizes = '(min-width: 990px) 1200px, 100vw';
        img.srcset = e.dataset.srcset || '';
        img.src = e.dataset.bild || '';
      }

      var beobachter = new IntersectionObserver(function (liste) {
        imBild = liste[liste.length - 1].isIntersecting;
        if (imBild) plane(); else halt();
      }, { threshold: 0.25 });
      beobachter.observe(buehne);

      document.addEventListener('visibilitychange', function () {
        verborgen = document.hidden;
        if (verborgen) halt(); else plane();
      });

      if (maus) {
        wurzel.addEventListener('mouseenter', function () { zeiger = true; halt(); });
        wurzel.addEventListener('mouseleave', function () { zeiger = false; plane(); });
      }
      wurzel.addEventListener('focusin', function () { fokus = true; halt(); });
      wurzel.addEventListener('focusout', function (ev) {
        if (wurzel.contains(ev.relatedTarget)) return;
        fokus = false;
        plane();
      });

      if (editor) {
        document.addEventListener('shopify:block:select', function (ev) {
          var i = eintraege.indexOf(ev.target);
          if (i >= 0) zeige(i, reduziert);
        });
      }
    });
  }

  /* ----------------------------------------------------------------
     Produktseite auf dem Handy nach Prada (Spec Etappe 4, 3.6)

     Das CSS (Abschnitt 30) macht aus Dawns Bilderliste eine senkrechte
     Rolle und laesst den Kaufknopf am unteren Rand kleben. Das Skript
     tut nur zwei Dinge, die CSS nicht kann:

     1. Die Lasche messen — der Teil des Blatts, der im Ruhezustand
        unter der Galerie sichtbar bleibt (Griff, Marke, Titel, Preis,
        Pflichtzeile, dazu die Hoehe des Kaufknopfs). Sie haengt an der
        Zeilenzahl des Titels und der geladenen Schrift, darum ein
        ResizeObserver. Ohne Skript gilt der Ersatzwert aus dem CSS.
     2. Bildpunkte links (IMG_6830) statt Dawns Zaehler "1/11": der
        aktive Punkt folgt der Rolle, Antippen scrollt zum Bild.
     ---------------------------------------------------------------- */
  function produktgalerie() {
    var handy = window.matchMedia('(max-width: 749px)');
    var huelle = document.querySelector('.product__media-wrapper');
    var rolle = huelle && huelle.querySelector('.product__media-list');
    var blatt = document.querySelector('.product__info-wrapper');
    var spalte = document.querySelector('.product__info-container');
    if (!rolle || !blatt || !spalte) return;

    var wurzel = document.documentElement;
    var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* 1. Lasche */
    var angefordert = false;
    function messeLasche() {
      angefordert = false;
      if (!handy.matches) {
        wurzel.style.removeProperty('--comet-lasche');
        return;
      }
      var erster = spalte.querySelector(
        ':scope > variant-selects, :scope > .comet-einzelstueck, :scope > .comet-angaben'
      );
      var knopf = spalte.querySelector('.product-form__submit');
      if (!erster || !knopf) return;
      var lasche = erster.getBoundingClientRect().top - blatt.getBoundingClientRect().top
        + knopf.offsetHeight;
      if (lasche > 0) wurzel.style.setProperty('--comet-lasche', Math.round(lasche) + 'px');
    }
    function planeMessung() {
      if (angefordert) return;
      angefordert = true;
      window.requestAnimationFrame(messeLasche);
    }
    messeLasche();
    if ('ResizeObserver' in window) {
      new ResizeObserver(planeMessung).observe(spalte);
    }
    window.addEventListener('resize', planeMessung);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(planeMessung);

    /* 2. Bildpunkte */
    var bilder = Array.prototype.slice.call(rolle.querySelectorAll('.product__media-item'));
    if (bilder.length < 2 || huelle.querySelector('.comet-galerie__punkte, .comet-galerie__zaehler')) return;

    /* Ab 8 Bildern wird die Punktreihe zur Leiter ueber das halbe Foto
       (Julius fotografiert 10 bis 18 Bilder je Teil). Dann ein Zaehler. */
    if (bilder.length > 7) {
      var zaehler = document.createElement('p');
      zaehler.className = 'comet-galerie__zaehler';
      zaehler.setAttribute('aria-live', 'polite');
      zaehler.textContent = '1 / ' + bilder.length;
      huelle.appendChild(zaehler);
      if ('IntersectionObserver' in window) {
        var zaehlBeobachter = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            if (e.isIntersecting) zaehler.textContent = (bilder.indexOf(e.target) + 1) + ' / ' + bilder.length;
          });
        }, { root: rolle, threshold: 0.6 });
        bilder.forEach(function (b) { zaehlBeobachter.observe(b); });
      }
      return;
    }

    var punkte = document.createElement('ol');
    punkte.className = 'comet-galerie__punkte list-unstyled';
    punkte.setAttribute('aria-label', 'Bilder');
    var knoepfe = bilder.map(function (bild, i) {
      var li = document.createElement('li');
      var k = document.createElement('button');
      k.type = 'button';
      k.className = 'comet-galerie__punkt' + (i === 0 ? ' comet-galerie__punkt--aktiv' : '');
      k.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + bilder.length);
      k.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      k.addEventListener('click', function () {
        var ziel = bild.getBoundingClientRect().top - rolle.getBoundingClientRect().top + rolle.scrollTop;
        rolle.scrollTo({ top: ziel, behavior: reduziert.matches ? 'auto' : 'smooth' });
      });
      li.appendChild(k);
      punkte.appendChild(li);
      return k;
    });
    huelle.appendChild(punkte);

    function markiere(i) {
      knoepfe.forEach(function (k, j) {
        k.classList.toggle('comet-galerie__punkt--aktiv', j === i);
        k.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }
    if ('IntersectionObserver' in window) {
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) markiere(bilder.indexOf(e.target));
        });
      }, { root: rolle, threshold: 0.6 });
      bilder.forEach(function (b) { beobachter.observe(b); });
    }
  }

  /* ----------------------------------------------------------------
     Warenkorb-Blatt: nach unten ziehen schliesst (Spec Etappe 4, 4)

     Das Blatt (snippets/comet-warenkorb.liquid, CSS Abschnitt 10) faehrt
     auf dem Handy von unten hoch. Erik: "man kann den gerade nicht wieder
     nach unten swipen zum Schliessen". Hier die Geste: Finger auf Griff
     oder Kopfzeile, das Blatt folgt nach unten (nach oben nur gedaempft),
     beim Loslassen zaehlt der Schwung, nicht nur der Weg (Emil: eine
     kurze schnelle Bewegung reicht). Tippen auf den Griff schliesst.

     Dawn tauscht den Inhalt von #CartDrawer bei jedem Ablegen aus —
     deshalb haengen die Ereignisse am bleibenden Element cart-drawer,
     nicht am Blatt. Dawns close() bleibt der einzige Weg zu. Es wird
     erst im Moment der Geste geprueft: cart-drawer.js laedt nach
     comet.js, beim Start ist das Element noch nicht aufgeruestet
     (gemessen 2026-09-09: die Geste blieb deshalb stumm).
     ---------------------------------------------------------------- */
  function warenkorbBlatt() {
    var blatt = document.querySelector('cart-drawer');
    if (!blatt) return;
    function schliesse() {
      if (typeof blatt.close === 'function') blatt.close();
      else blatt.classList.remove('active');
    }
    var handy = window.matchMedia('(max-width: 749px)');
    var zug = null;
    /* Bricht eine laufende Rueckkehr ab, ohne sie zu vollenden. Ohne das
       feuert der alte transitionend-Handler mitten in den neuen Zug und
       setzt die Transition zurueck — die Flaeche wuerde dem Finger dann
       traege hinterherlaufen. */
    var abbruch = null;

    function aufraeumen(inner) {
      inner.style.transition = '';
      inner.style.transform = '';
    }

    /* Wie weit die Flaeche gerade verschoben ist. Beim erneuten Greifen
       waehrend des Zurueckschnellens ist das der Startpunkt — sonst
       springt sie von ihrer Zwischenposition sofort auf null
       (Bewegungs-Durchsicht 2026-09-09). */
    function versatz(inner) {
      var t = window.getComputedStyle(inner).transform;
      if (!t || t === 'none') return 0;
      var zahlen = t.slice(t.indexOf('(') + 1, t.lastIndexOf(')')).split(',');
      var y = parseFloat(zahlen[zahlen.length - 1]);
      return isNaN(y) ? 0 : y;
    }

    blatt.addEventListener('pointerdown', function (ev) {
      if (!handy.matches || zug || (ev.pointerType === 'mouse' && ev.button !== 0)) return;
      var zone = ev.target.closest('.comet-blatt__griff, .drawer__header');
      if (!zone || ev.target.closest('.drawer__close')) return;
      var inner = blatt.querySelector('.drawer__inner');
      if (!inner) return;
      var start = versatz(inner);
      if (abbruch) abbruch();
      zug = {
        id: ev.pointerId,
        y: ev.clientY,
        start: start,
        dy: start,
        // Fuer den Schwung zaehlt der letzte Abschnitt, nicht der ganze Zug:
        // wer erst langsam zieht und dann loslaesst, soll nicht schliessen.
        letzteY: ev.clientY,
        letzteZeit: ev.timeStamp,
        schwung: 0,
        inner: inner,
        zone: zone
      };
      inner.style.transition = 'none';
      try { zone.setPointerCapture(ev.pointerId); } catch (e) { /* synthetische Zeiger */ }
    });

    blatt.addEventListener('pointermove', function (ev) {
      if (!zug || ev.pointerId !== zug.id) return;
      var dy = zug.start + (ev.clientY - zug.y);
      var dt = ev.timeStamp - zug.letzteZeit;
      if (dt > 0) zug.schwung = (ev.clientY - zug.letzteY) / dt;
      zug.letzteY = ev.clientY;
      zug.letzteZeit = ev.timeStamp;
      zug.dy = dy;
      // Nach oben nur ein Viertel: Widerstand statt harter Grenze.
      var y = dy > 0 ? dy : dy / 4;
      zug.inner.style.transform = 'translateY(' + y + 'px)';
    });

    function loslassen(ev) {
      if (!zug || ev.pointerId !== zug.id) return;
      var z = zug;
      zug = null;
      var inner = z.inner;
      var erledigt = false;

      if (Math.abs(z.dy) < 5) {
        // Ein Tipp: sofort zurueck, das click-Ereignis schliesst ggf.
        aufraeumen(inner);
        return;
      }

      // Weit genug gezogen, oder kurz aber mit Schwung nach unten: ein
      // schneller Wisch soll reichen. 0,11 px/ms ist der Wert aus Sonner
      // (Emil Kowalski) — vorher stand hier 0,5, also das 4,5-fache, und
      // ein normaler Wisch zum Wegschieben reichte nicht. Unter 24 px
      // zaehlt nichts, sonst schliesst ein Zucken beim Antippen.
      if (z.dy > 80 || (z.dy > 24 && z.schwung > 0.11)) {
        var zuTimer;
        var zu = function () {
          if (erledigt) return;
          erledigt = true;
          window.clearTimeout(zuTimer);
          inner.removeEventListener('transitionend', zu);
          abbruch = null;
          schliesse();
          aufraeumen(inner);
        };
        abbruch = function () {
          erledigt = true;
          window.clearTimeout(zuTimer);
          inner.removeEventListener('transitionend', zu);
          abbruch = null;
        };
        inner.style.transition = 'transform 200ms var(--comet-kurve-aus)';
        inner.style.transform = 'translateY(100%)';
        inner.addEventListener('transitionend', zu);
        zuTimer = window.setTimeout(zu, 260);
      } else {
        var zurueckTimer;
        var zurueck = function () {
          if (erledigt) return;
          erledigt = true;
          window.clearTimeout(zurueckTimer);
          inner.removeEventListener('transitionend', zurueck);
          abbruch = null;
          inner.style.transition = '';
        };
        abbruch = function () {
          erledigt = true;
          window.clearTimeout(zurueckTimer);
          inner.removeEventListener('transitionend', zurueck);
          abbruch = null;
        };
        inner.style.transition = 'transform 200ms var(--comet-kurve-schublade)';
        inner.style.transform = '';
        inner.addEventListener('transitionend', zurueck);
        zurueckTimer = window.setTimeout(zurueck, 260);
      }
    }

    blatt.addEventListener('pointerup', loslassen);
    blatt.addEventListener('pointercancel', loslassen);

    blatt.addEventListener('click', function (ev) {
      if (ev.target.closest('.comet-blatt__griff')) schliesse();
    });
  }

  /* ----------------------------------------------------------------
     Bildrolle in der Karte: nur der aktive Punkt

     Das Wischen selbst ist nativ (Scroll-Snap, CSS-Abschnitt 33) —
     hier wird nichts bewegt. Der Beobachter meldet, welches Bild in
     der Rolle steht, und faerbt den passenden Punkt ein.

     IntersectionObserver statt eines scroll-Horchers: bei zwei Dutzend
     Karten mit je einem Horcher liefe waehrend jedes Wischens Arbeit
     im Hauptstrang. Der Beobachter meldet sich nur bei Wechseln.

     Nachgeladene Karten ("Mehr anzeigen") bringen eigene Rollen mit,
     darum ist die Funktion ueber einen Wurzelknoten erneut aufrufbar;
     data-rolle-fertig verhindert doppelte Beobachter.
     ---------------------------------------------------------------- */

  function kartenrollen(wurzel) {
    var bereich = wurzel || document;
    var rollen = bereich.querySelectorAll('[data-kartenrolle]');
    if (!rollen.length || !('IntersectionObserver' in window)) return;

    /* Als MediaQueryList behalten und erst beim Klick auswerten — sonst
       greift eine waehrend der Sitzung geaenderte Einstellung nicht.
       produktgalerie() macht es genauso. */
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');

    Array.prototype.forEach.call(rollen, function (rolle) {
      if (rolle.getAttribute('data-rolle-fertig')) return;
      rolle.setAttribute('data-rolle-fertig', '1');

      var kasten = rolle.parentNode;
      var punkte = kasten ? kasten.querySelector('[data-kartenpunkte]') : null;
      if (!punkte) return;

      var bilder = rolle.children;
      var knoepfe = punkte.children;

      /* Bild 2 bis 5 stehen im Markup nur als data-src. Sie werden
         geladen, sobald jemand die Rolle anfasst — nicht vorher.

         Warum nicht loading="lazy": der Browser prueft die senkrechte
         Sichtbarkeit, und die Rolle IST senkrecht sichtbar. Dass die
         Bilder waagerecht ausserhalb liegen, zaehlt fuer ihn nicht.
         Gemessen am 2026-09-10 luden dadurch auf der Startseite 16
         Bilder mit, die niemand zu sehen bekommt: rund 200 KB.

         Ausgeloest wird beim ersten Wischen, beim ersten Zeigergriff
         und beim Klick auf einen Punkt. Danach haengt sich der Zuhoerer
         selbst aus. */
      function ladeRest() {
        var offen = rolle.querySelectorAll('img[data-src]');
        Array.prototype.forEach.call(offen, function (bild) {
          var satz = bild.getAttribute('data-srcset');
          if (satz) bild.setAttribute('srcset', satz);
          bild.setAttribute('src', bild.getAttribute('data-src'));
          bild.removeAttribute('data-src');
          bild.removeAttribute('data-srcset');
        });
        rolle.removeEventListener('scroll', ladeRest);
        rolle.removeEventListener('pointerdown', ladeRest);
        rolle.removeEventListener('touchstart', ladeRest);
      }

      if (rolle.querySelector('img[data-src]')) {
        rolle.addEventListener('scroll', ladeRest, { passive: true, once: false });
        rolle.addEventListener('pointerdown', ladeRest, { passive: true });
        rolle.addEventListener('touchstart', ladeRest, { passive: true });
      }

      function setze(i) {
        for (var k = 0; k < knoepfe.length; k++) {
          if (k === i) {
            knoepfe[k].classList.add('comet-kartenpunkte__punkt--aktiv');
          } else {
            knoepfe[k].classList.remove('comet-kartenpunkte__punkt--aktiv');
          }
        }
      }

      var beobachter = new IntersectionObserver(
        function (eintraege) {
          for (var i = 0; i < eintraege.length; i++) {
            if (eintraege[i].isIntersecting) {
              setze(Array.prototype.indexOf.call(bilder, eintraege[i].target));
            }
          }
        },
        { root: rolle, threshold: 0.6 }
      );

      Array.prototype.forEach.call(bilder, function (bild) {
        beobachter.observe(bild);
      });

      /* Am Rechner ohne Wischflaeche fuehrt der Punkt zum Bild. */
      punkte.addEventListener('click', function (ev) {
        var knopf = ev.target.closest('.comet-kartenpunkte__punkt');
        if (!knopf) return;
        ladeRest();
        var i = parseInt(knopf.getAttribute('data-bild'), 10) || 0;
        rolle.scrollTo({
          left: rolle.clientWidth * i,
          behavior: ruhig.matches ? 'auto' : 'smooth'
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     Rechtstexte: Abschnitte auszeichnen, Inhaltsverzeichnis bauen

     Die vier Richtlinien und das Impressum kommen als ein Block HTML
     aus dem Shopify-Admin. Der Text bleibt Wort fuer Wort, wie er ist
     (CLAUDE.md: wir formulieren keine Rechtstexte) — hier wird nur
     ausgezeichnet, was ohnehin schon eine Gliederung ist.

     Der Datenschutztext hat auf 32.000 Zeichen keine einzige echte
     Ueberschrift, und er ist uneinheitlich gesetzt. Gemessen am
     2026-09-09 stehen dort nebeneinander:

       <ol><li><strong>Empfaenger und Empfaengerkategorien</strong></li></ol>
       <p>2.<strong>&nbsp;Datenkategorien, Zweck ...</strong></p>
       <p>2.2.<strong>&nbsp;Cookies</strong></p>
       <p>2.2.1. Notwendige Cookies</p>

     Mal ist die Nummer in der Liste, mal getippt; mal ist der Text
     fett, mal nicht. Fettschrift taugt darum nicht als Erkennung —
     die Nummerierung schon. Gesucht wird ein kurzer Absatz, der mit
     einer Gliederungsnummer beginnt und nicht wie ein Satz endet.

     Die sieben <ol> mit genau einem <li> sind die oberste Ebene.
     ACHTUNG: keiner davon hat ein start-Attribut, sie zaehlen also
     alle wieder bei 1 an — die Seite zeigt sieben Abschnitte "1."
     Das ist ein Fehler im Text selbst und wird hier NICHT korrigiert:
     wir aendern keine Rechtstexte, auch keine Nummern, an denen
     Querverweise haengen koennen. Steht als Befund im Protokoll.

     Ohne dieses Skript bleibt der Text vollstaendig lesbar, nur ohne
     Sprungmarken. Progressive Enhancement wie ueberall hier.
     ---------------------------------------------------------------- */

  /* "2." und "2.2." und "2.2.1." — die Zahl der Punkte ist die Ebene. */
  var GLIEDERUNG = /^(\d+(?:\.\d+)*)\.[\s\u00a0]+\S/;

  function istUeberschrift(text) {
    if (!text || text.length > 140) return false;
    if (/[.:;,]$/.test(text)) return false;
    return GLIEDERUNG.test(text);
  }

  function rechtstexte() {
    var koerper = document.querySelector(
      '.shopify-policy__body .rte, .main-page-title + .rte'
    );
    if (!koerper) return;

    var ebene1 = [];
    var gefunden = 0;

    Array.prototype.forEach.call(koerper.children, function (kind) {
      var text = (kind.textContent || '').trim();
      if (!text) return;

      /* Oberste Ebene: eine Liste mit genau einem Eintrag. Shopifys
         Editor macht daraus eine nummerierte Ueberschrift. */
      if (kind.tagName === 'OL' && kind.children.length === 1 && text.length <= 140) {
        kind.classList.add('comet-recht__abschnitt');
        ebene1.push(kind);
        gefunden++;
        return;
      }

      /* Echte Ueberschriften nimmt Shopify nur selten mit — die
         Versandseite hat zwei h4. */
      if (/^H[2-6]$/.test(kind.tagName)) {
        kind.classList.add('comet-recht__abschnitt');
        ebene1.push(kind);
        gefunden++;
        return;
      }

      if (kind.tagName !== 'P') return;
      if (!istUeberschrift(text)) return;

      var nummer = text.match(GLIEDERUNG)[1];
      var tiefe = nummer.split('.').length;

      if (tiefe === 1) {
        kind.classList.add('comet-recht__abschnitt');
        ebene1.push(kind);
      } else {
        kind.classList.add('comet-recht__unterabschnitt');
      }
      gefunden++;
    });

    if (!gefunden) return;

    ebene1.forEach(function (el, i) {
      if (!el.id) el.id = 'recht-' + (i + 1);
    });

    /* Ein Inhaltsverzeichnis lohnt erst, wenn die Seite laenger ist als
       das Verzeichnis selbst. Unter sechs Abschnitten waere es nur eine
       zweite Ueberschriftenliste ueber demselben Text. Aufgefuehrt wird
       nur die oberste Ebene — sonst steht der halbe Text zweimal da. */
    if (ebene1.length < 6) return;

    var nav = document.createElement('nav');
    nav.className = 'comet-recht__inhalt';
    nav.setAttribute('aria-label', 'Inhalt');

    var titel = document.createElement('p');
    titel.className = 'comet-recht__inhalt-titel';
    titel.textContent = 'Inhalt';
    nav.appendChild(titel);

    var liste = document.createElement('ul');
    liste.className = 'comet-recht__inhalt-liste';

    ebene1.forEach(function (el) {
      var eintrag = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + el.id;
      /* Bei den Listen-Ueberschriften steht die Nummer im Marker und
         damit nicht in textContent, bei den getippten schon. Ohne
         Bereinigung faengt ein Eintrag mit "2." an und die uebrigen
         sieben mit einem Wort. Und weil die Nummerierung im Text
         ohnehin defekt ist (sieben Abschnitte "1."), waere sie im
         Verzeichnis nicht nur uneinheitlich, sondern falsch. */
      link.textContent = (el.textContent || '')
        .trim()
        .replace(/^\d+(?:\.\d+)*\.[\s\u00a0]+/, '');
      eintrag.appendChild(link);
      liste.appendChild(eintrag);
    });

    nav.appendChild(liste);
    koerper.parentNode.insertBefore(nav, koerper);
  }

  /* ------------------------------------------------------------------
     Bewertungs-Laufband: haelt an, solange es nicht im Bild ist oder der
     Tab verborgen liegt. Gleiches Muster wie die Markenbuehne — ein
     endloses Band, das niemand sieht, ist Arbeit fuer den Kompositor und
     sonst nichts. Die Bewertungen sitzen weit unten auf der Startseite,
     also laeuft das Band im Normalfall die ganze Lesezeit ungesehen mit.
     ------------------------------------------------------------------ */
  function bewertungslauf() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.comet-bewertungen__lauf').forEach(function (huelle) {
      if (huelle.dataset.lauf) return;
      huelle.dataset.lauf = '1';
      var imBild = false;

      function pruefe() {
        huelle.classList.toggle(
          'comet-bewertungen__lauf--halt',
          !imBild || document.hidden
        );
      }

      new IntersectionObserver(function (liste) {
        imBild = liste[liste.length - 1].isIntersecting;
        pruefe();
      }, { threshold: 0 }).observe(huelle);

      document.addEventListener('visibilitychange', pruefe);
      pruefe();
    });
  }

  /* ----------------------------------------------------------------
     Kachelreihe beim Umschalten "Fuer sie / Fuer ihn" an den Anfang

     Erik 2026-10-25 (Screenshots): nach "Fuer ihn" und zurueck stand
     "Fuer sie" um eine Kachel verschoben, die Taschen links
     angeschnitten. Bei "Fuer ihn" faellt Taschen weg, die Reihe beginnt
     mit Jacken. Chrome haelt bei scroll-snap das eingerastete Element
     fest: kommt Taschen zurueck, scrollt es um eine Kachel weiter, damit
     Jacken vorn bleibt. Nach dem Umschalten beginnt die Reihe darum
     immer vorn — ohne Gleiten, es ist ein neuer Inhalt, kein Weg.
     An document gehaengt, damit auch im Theme-Editor neu gerenderte
     Sections greifen.
     ---------------------------------------------------------------- */

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.classList || !radio.classList.contains('kat-umschalter__radio')) return;
    var karussell = radio.closest('.kat-karussell');
    var spur = karussell && karussell.querySelector('.kat-karussell__spur');
    if (!spur) return;
    // Erst nach dem Neuaufbau der Reihe, sonst rastet Chrome danach wieder ein.
    requestAnimationFrame(function () {
      spur.scrollTo({ left: 0, behavior: 'instant' });
    });
  });

  function start() {
    mehrAnzeigen();
    kartenrollen();
    startbildVideo();
    katalog();
    filterlinien();
    filterNachladen();
    leereMasse();
    empfehlungen();
    marken();
    produktgalerie();
    warenkorbBlatt();
    rechtstexte();
    bewertungslauf();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Der Theme-Editor rendert Sections neu; neue Marken-Sections
     werden dann nachtraeglich eingerichtet (der data-marken-Schutz
     verhindert Doppeltes). */
  document.addEventListener('shopify:section:load', function () {
    marken();
    bewertungslauf();
  });
})();
